export default __webpack_public_path__ + "static/mesheryctl-docs-41d12c696f8911115f18426c4da44277.webp";